<script lang="ts">
	import { Alert } from '@Shelly/shelly-design-system/index';
	import TransitionWrapper from 'src/components/Utility/TransitionWrapper.svelte';
	import { capFirstChar } from 'src/helpers/utilities';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import {
		BLU_CONN_STATUSES_THAT_DO_NOT_SHOW,
		BLU_STATUS,
	} from 'src/types/requests/settings/blu_status';
	import { format } from 'svelte-i18n';

	export let showExpiredMsg = false;

	$: showExpireHeading = capFirstChar(
		showExpiredMsg
			? $format('heading_connection_expired_press_again', {
					default: 'Connection expired, please press the device button again.',
				})
			: $format('button_press_required', {
					default: 'Please press device button.',
				}),
	);
</script>

{#if $controlBleDevice.searchingState}
	<TransitionWrapper>
		<Alert
			class="mb-s"
			isHeadingBold
			heading={showExpireHeading}
			message={$format('message_get_bluetooth_status', {
				default:
					'To change some settings, you need to get the latest bluetooth status of the device, by pressing the device button.',
			})}
		/>
	</TransitionWrapper>
	<!-- show every possible ble connection status, except these from BLU_CONN_STATUSES_THAT_DO_NOT_SHOW -->
{:else if $controlBleDevice.connectionState > 0 && !BLU_CONN_STATUSES_THAT_DO_NOT_SHOW.includes($controlBleDevice.currentStatusIndex)}
	<TransitionWrapper>
		<Alert
			class="mb-s"
			heading={$controlBleDevice.currentStatusIndex !== BLU_STATUS.CONNECT_TO_DEVICE
				? capFirstChar($format($controlBleDevice.currentStatusTranslationKey))
				: `${capFirstChar(
						$format($controlBleDevice.currentStatusTranslationKey),
					)}. ${$format('press_button_required')}`}
		/>
	</TransitionWrapper>
{/if}
{#if $controlBleDevice.currentStatusIndex === BLU_STATUS.UNHANDLED_STATE}
	<Alert
		class="mb-s"
		type="warning"
		heading={capFirstChar(
			$format('device_bluetooth_disabled', {
				default: 'Bluetooth disabled',
			}),
		)}
		message={$format('cant_connect_to_bluetooth', {
			default: 'Unable to connect to Bluetooth device.',
		})}
	/>
{/if}
